exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cw-spin-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);

// exports
